/**
 * 通用增强表格包装器
 * 为任何 Ant Design Table 添加列调整功能
 */
import React, { useMemo } from 'react';
import type { TableProps } from 'antd';
import ResizableTable from '../ResizableTable';
import TableColumnSettings from '../TableColumnSettings';
import { useTableColumns, ColumnConfig } from '../../hooks/useTableColumns';

interface EnhancedTableWrapperProps extends Omit<TableProps<any>, 'columns'> {
  viewType: string;
  defaultColumns: ColumnConfig[];
  columnRenderMap: Record<string, any>;
  showColumnSettings?: boolean;
}

const EnhancedTableWrapper: React.FC<EnhancedTableWrapperProps> = ({
  viewType,
  defaultColumns,
  columnRenderMap,
  showColumnSettings = true,
  ...tableProps
}) => {
  const {
    columns: columnConfigs,
    updateColumnWidth,
    updateColumnOrder,
    updateColumnVisibility,
    resetSettings,
  } = useTableColumns(viewType, defaultColumns);

  // 合并列配置和渲染逻辑
  const columns = useMemo(() => {
    return columnConfigs
      .filter(col => col.visible)
      .map(col => ({
        ...col,
        ...(columnRenderMap[col.key] || {}),
      }));
  }, [columnConfigs, columnRenderMap]);

  return (
    <>
      {showColumnSettings && (
        <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'flex-end' }}>
          <TableColumnSettings
            columns={columnConfigs}
            onVisibilityChange={updateColumnVisibility}
            onOrderChange={updateColumnOrder}
            onReset={resetSettings}
          />
        </div>
      )}

      <ResizableTable
        {...tableProps}
        columns={columns}
        onColumnResize={updateColumnWidth}
      />
    </>
  );
};

export default EnhancedTableWrapper;
